export default __webpack_public_path__ + "static/media/VEUE-Grand_Stacked Logo_RGB_White.96789ac7.png";